// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  LS_ABWORKFLOW_CORE_API_ENDPOINT: 'LS_ABWORKFLOW_CORE_API_ENDPOINT',
  LS_ABWORKFLOW_CORE_API_AUTH_SESSION: 'LS_ABWORKFLOW_CORE_API_AUTH_SESSION',
  LS_ABWORKFLOW_CORE_API_AUTH_USERNAME: 'LS_ABWORKFLOW_CORE_API_AUTH_USERNAME',
  LS_ABWORKFLOW_CORE_APP_MODE: 'LS_ABWORKFLOW_CORE_APP_MODE',
  LS_ABWORKFLOW_ENCRYPTED_PWD: "LS_ABWORKFLOW_ENCRYPTED_PWD",
  LS_ABWORKFLOW_APP_VERSION: "LS_ABWORKFLOW_APP_VERSION",
  LS_ABWORKFLOW_LAST_DATE_SYNCHRONISATION: "LS_ABWORKFLOW_LAST_DATE_SYNCHRONISATION",
  LS_ABWORKFLOW_CODE_SOCIETE: "LS_ABWORKFLOW_CODE_SOCIETE",
  LS_ABWORKFLOW_NOM_SOCIETE: "LS_ABWORKFLOW_NOM_SOCIETE",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
